<div class="search-panel ev-card" data-testid="search-panel">
  <app-search [failedPlan]="false"></app-search>
</div>
